import { ITopToursCategory } from "..";

export interface ICategoryNavItem { 
    name: string
    icon: string
    filter: { hasCoupons: boolean, categories: number[] }
}

export const toTourCategory = (item: ICategoryNavItem) => ({ name: item.name, icon: item.icon, categories: item.filter.categories }) as ITopToursCategory

export const topCategories: ICategoryNavItem[] = [
    {
        name: 'Virtual Tours',
        icon: '/images/icons/small-icon-virtual-tours.png',
        filter: {
            hasCoupons: false,
            categories: []
        }
    },
    {
        name: 'Hotels',
        icon: '/images/icons/small-icon-hotels.png',
        filter: {
            hasCoupons: false,
            categories: [33, 34, 35, 59, 58, 57, 85, 88]
        }
    },
    {
        name: 'Villas',
        icon: '/images/icons/small-icon-villas.png',
        filter: {
            hasCoupons: false,
            categories: [85,91,92,96]
        }
    },
    // {
    //     name: 'Flights',
    //     icon: '/images/icons/small-icon-flights.png'
    // },
    {
        name: 'Tourist Attractions',
        icon: '/images/icons/small-icon-activities.png',
        filter: {
            hasCoupons: false,
            categories: [18, 19, 20, 21, 22, 23, 24, 25, 39, 40, 74, 50, 76, 73, 75, 101, 99]
        }
    },
    {
        name: 'Restaurants',
        icon: '/images/icons/small-icon-restaurants.png',
        filter: {
            hasCoupons: false,
            categories: [26,27,28,29,30,31,32,43]
        }
    },
    {
        name: 'Coupons',
        icon: '/images/icons/small-icon-coupons.png',
        filter: {
            hasCoupons: true,
            categories: []
        }
    },
    // {
    //     name: 'Jobs',
    //     icon: '/images/icons/small-icon-jobs.png'
    // }
]